import { optionOperation, toFilterString, makeFilterFunction, evalExpression, deepcopy, datumMatch, covertMarkConditionPredicateToObject, covertMarkConditionObjectToPredicate } from './utility.js';
import * as d3 from 'd3';
import { isLayerWithQuery } from './layer.js';
export const propChannels = ["color", "stroke", "fillOpacity", "strokeOpacity", "opacity",
  "shape", "strokeDash", "strokeWidth", "size", "url", "fill",
  "angle", "theta", "radius", "radius2", "detail", "order"];

export function MarkTransformation(role, spec, original, specifier, action, option) {
  let toRemove = [];
  spec.layer.forEach((layerItem, li) => {
    //todo: channel/encoded field-wise filtering
    if (!layerItem.mark) return;
    let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.index, specifier.id);
    let encoded_fields = Object.keys(layerItem.mark).map(d => d.field).filter(d => d !== undefined);
    let encoded_channels = Object.keys(layerItem.mark).filter(d => propChannels.includes(d));
    if (specifier.mark !== undefined && specifier.mark !== layerItem.mark.type) flag = false;
    if (specifier.field !== undefined && !encoded_fields.includes(specifier.field)) flag = false;
    if (specifier.channel !== undefined) {
      if (specifier.channel.constructor.name === "String" && !encoded_channels.includes(specifier.channel)) flag = false;
      else if (specifier.channel.constructor.name === "Array") {
        if (specifier.channel.field !== undefined && !specifier.channel.every(ch => encoded_channels.includes(ch))) flag = false;
      }
    }
    propChannels.forEach(ch => {
      if (specifier[ch] !== undefined) {
        if (specifier[ch].field !== undefined && specifier[ch].field !== layerItem.mark[ch]?.field) flag = false;
        else if (specifier[ch].value !== undefined && specifier[ch].value !== layerItem.mark[ch]?.value) flag = false;
        // todo: expand
      }
    });
    // if (specifier.index !== undefined && specifier.index !== li) flag = false;
    if (flag) {
      if (action === "add") {
        if (option) {
          let squareToImage;
          if (option.channel) {
            let imageToSquare;
            if (option.channel.constructor.name === "Array") {
              option.channel.forEach(channel => {
                layerItem.mark[channel] = channel;
                if (channel === "url") squareToImage = true;
              })
            } else if (option.channel.constructor.name === "String") {
              layerItem.mark[option.channel] = {};
              let channel_data = option[option.channel]
              if (channel_data.field !== undefined) {
                layerItem.mark[option.channel].field = channel_data.field;
                if (channel_data.scale !== undefined) {
                  layerItem.mark[option.channel].scale = channel_data.scale;
                }
                if (channel_data.aggregae !== undefined) {
                  layerItem.mark[option.channel].aggregae = channel_data.aggregae;
                }
                if (option[option.channel].bin !== undefined) {
                  layerItem.mark[option.channel].bin = {};
                  Object.keys(channel_data.bin).forEach(subPropkey => {
                    let _subPropkey = { "nBins": "maxbins", "nice": "nice", "minstep": "minstep", "step": "step", "steps": "steps" }[subPropkey]
                    layerItem.mark[option.channel].bin[_subPropkey] = channel_data.bin[subPropkey];
                  });
                }
              }
              if (channel_data.value !== undefined) {
                layerItem.mark[option.channel].value = channel_data.value;
              }
              if (option.channel === "url") imageToSquare = true;
            }
            if (imageToSquare) {
              layerItem.mark.type = "image";
              if (layerItem.mark.width !== undefined && layerItem.mark.height !== undefined) {
                layerItem.mark.size = { value: layerItem.mark.width * layerItem.mark.height }
              } else if (layerItem.mark.width !== undefined) {
                layerItem.mark.size = { value: layerItem.mark.width * layerItem.mark.width }
              } else if (layerItem.mark.height !== undefined) {
                layerItem.mark.size = { value: layerItem.mark.height * layerItem.mark.height }
              }
            }
          } else if (option.role === "tooltip") {
            layerItem.tooltip = {
              "visibility": "on-mark"
            };
            if (option.tooltip?.external == true && option.tooltip?.fixed == true) layerItem.mark.tooltip.fixed = true;
            else layerItem.tooltip.fixed = false;
            if (option.fields) {
              layerItem.tooltip.fields = deepcopy(option.fields);
            } else if (layerItem.tooltip.fields === undefined || layerItem.tooltip.fields.length == 0) {
              layerItem.tooltip.fields = [];
              let fields = [];
              spec?.layout?.row.forEach((f) => {
                fields.push(f.field);
              });
              spec?.layout?.column.forEach((f) => {
                fields.push(f.field);
              });
              Object.keys(layerItem.mark).forEach((enc) => {
                if (layerItem.mark[enc].field !== undefined)
                  fields.push(layerItem.mark[enc].field);
              });
              layerItem.text?.forEach((text) => {
                if (text.field !== undefined && !fields.includes(text.field)) {
                  fields.push(text.field);
                }
              });
              fields.forEach((field) => {
                layerItem.tooltip.fields.push({ field });
              });
            }
          } else if (option.role === "label") {
            let newTextItem = { "type": "on-mark", "items": [] };
            // if (option.items !== undefined) newTextItem.items = deepcopy(option.items);
            Object.keys(option).forEach(propKey => {
              if (["field", "dx", "dy", "anchor", "orient", "visibility", "values", "id"].includes(propKey)) {
                // global
                let _propKey = { "anchor": "anchorAlign", "id": "name" }[propKey] || propKey;
                newTextItem[_propKey] = option[propKey];
              } if (propKey === "items") {
                if (option.items.constructor.name === "Array") {
                  option.items?.forEach((newItemDef) => {
                    newTextItem.items.push(newItemDef);
                  });
                } else if (option.items.constructor.name === "Object") {
                  // todo: fix;
                  newTextItem.items = [deepcopy(option.items)];
                } else {
                  newTextItem.items = [{}];
                }
              }
            });
            if (layerItem.text === undefined) layerItem.text = [];
            layerItem.text.push(newTextItem)
          } else {
            Object.keys(option).forEach(propKey => {
              if (propChannels.includes[propKey]) {
                layerItem.mark[propKey] = {};
              }
            });
          }
        } else {
          //todo: add layer
        }
      } else if (action === "remove") {
        if (option) {
          if (option.channel) {
            let imageToSquare;
            if (option.channel.constructor.name === "Array") {
              option.channel.forEach(channel => {
                delete layerItem.mark[channel];
                if (channel === "url" && layerItem.mark.type === "image") imageToSquare = true;
              })
            } else if (option.channel.constructor.name === "String") {
              delete layerItem.mark[option.channel];
              if (option.channel === "url" && layerItem.mark.type === "image") imageToSquare = true;
            }
            if (imageToSquare) {
              layerItem.mark.type = "square";
              if (layerItem.mark.width !== undefined && layerItem.mark.height !== undefined) {
                layerItem.mark.size = { value: layerItem.mark.width * layerItem.mark.height }
              } else if (layerItem.mark.width !== undefined) {
                layerItem.mark.size = { value: layerItem.mark.width * layerItem.mark.width }
              } else if (layerItem.mark.height !== undefined) {
                layerItem.mark.size = { value: layerItem.mark.height * layerItem.mark.height }
              }
            }
          }
        } else {
          toRemove.push(li);
        }
      } else if (action === "modify") {
        if (specifier.data) {
          if (option) {
            // datumMatch, covertMarkConditionPredicateToObject, covertMarkConditionObjectToPredicate
            Object.keys(option).forEach(propertyKey => {
              if (propertyKey === "data") {
                Object.keys(layerItem.mark).forEach((markProp) => {
                  if (propChannels.includes(markProp) && layerItem.mark[markProp].conditions) {
                    layerItem.mark[markProp].conditions.forEach((cond) => {
                      if (datumMatch(specifier.data, covertMarkConditionPredicateToObject(cond.condition || {}))) {
                        cond.condition = covertMarkConditionObjectToPredicate(option.data);
                      }
                    })
                  }
                })
              } else if (!["role", "mark"].includes(propertyKey)) {
                if (layerItem.mark[propertyKey] === undefined) {
                  layerItem.mark[propertyKey] = {};
                }
                if (layerItem.mark[propertyKey].conditions === undefined) {
                  layerItem.mark[propertyKey].conditions = [];
                }
                let existing = layerItem.mark[propertyKey].conditions.map((cond, i) => {
                  return (datumMatch(specifier.data, covertMarkConditionPredicateToObject(cond.condition || "")) ? i : undefined);
                }).filter(d => d !== undefined)[0];
                if (existing !== undefined) {
                  if (option[propertyKey] === null) {
                    layerItem.mark[propertyKey].conditions.splice(existing, 1);
                  } else {
                    layerItem.mark[propertyKey].conditions[existing] = option[propertyKey].value || option[propertyKey];
                  }
                } else {
                  if (option[propertyKey] !== null) {
                    layerItem.mark[propertyKey].conditions.push(
                      {
                        "condition": covertMarkConditionObjectToPredicate(specifier.data),
                        "value": option[propertyKey].value || option[propertyKey]
                      }
                    );
                  }
                }
                // if (layerItem.mark[propertyKey].value !== undefined) {
                //   // value wise
                //   if (layerItem.mark[propertyKey].conditions === undefined) layerItem.mark[propertyKey].conditions = []
                //   let existing = layerItem.mark[propertyKey].conditions.map((d, di) => d.condition === fstr ? di : undefined).filter(d => d !== undefined)[0]
                //   if (existing !== undefined) {
                //     layerItem.mark[propertyKey].conditions[existing].value = option[propertyKey].value || option[propertyKey];
                //   } else {
                //     layerItem.mark[propertyKey].conditions.push(
                //       {
                //         "text": fstr,
                //         "value": option[propertyKey].value || option[propertyKey]
                //       }
                //     );
                //   }
                // }
                // // todo -- encoding-wise;
                // else if (layerItem.mark[propertyKey].field !== undefined) {
                //   // scale;
                //   if (option[propertyKey].scale?.range !== undefined) {
                //     let newRange = option[propertyKey].scale?.range;
                //     if (newRange.constructor.name === "Object" && newRange.prod !== undefined) {
                //       if (layerItem.mark[propertyKey].range?.constructor.name === "Array") {
                //         layerItem.mark[propertyKey].range = layerItem.mark[propertyKey].range.map(d => d * newRange.prod)
                //       }
                //     } else if (newRange.constructor.name === "Object" && newRange.by !== undefined) {
                //       if (layerItem.mark[propertyKey].range?.constructor.name === "Array") {
                //         layerItem.mark[propertyKey].range = layerItem.mark[propertyKey].range.map(d => d + newRange.by)
                //       }
                //     }

                //   }
                // }
              }
            })
          }
        } else if (option) {
          Object.keys(option).forEach(propertyKey => {
            if (propertyKey === "mark") {
              layerItem.mark.type = option[propertyKey];
              if (!["line", "area"].includes(option[propertyKey]) && layerItem.mark.point) {
                delete layerItem.mark.point;
              }
            } else if (propChannels.includes(propertyKey)) {
              if (option[propertyKey] === null) {
                delete layerItem.mark?.[propertyKey];
              } else {
                if (layerItem.mark[propertyKey] === undefined) layerItem.mark[propertyKey] = {};
                if (option[propertyKey]?.value !== undefined) {
                  if (option[propertyKey].value === null) delete layerItem.mark[propertyKey]?.value;
                  else layerItem.mark[propertyKey].value = option[propertyKey].value;
                }
                if (option[propertyKey]?.field !== undefined) {
                  if (option[propertyKey].field === null) delete layerItem.mark[propertyKey]?.field;
                  else layerItem.mark[propertyKey].field = option[propertyKey].field;
                }
                if (option[propertyKey]?.aggregate !== undefined) {
                  if (option[propertyKey].aggregate === null) delete layerItem.mark[propertyKey]?.aggregate;
                  else layerItem.mark[propertyKey].aggregate = option[propertyKey].aggregate;
                }
                if (option[propertyKey]?.bin !== undefined) {
                  if (option[propertyKey].bin === null) delete layerItem.mark[propertyKey]?.bin;
                  else {
                    if (layerItem.mark[propertyKey].bin === undefined) layerItem.mark[propertyKey].bin = {};
                    Object.keys(option[propertyKey].bin).forEach(subPropkey => {
                      let _subPropkey = { "nBins": "maxbins", "nice": "nice", "minstep": "minstep", "step": "step", "steps": "steps" }[subPropkey]
                      layerItem.mark[propertyKey].bin[_subPropkey] = option[propertyKey].bin[subPropkey];
                    });
                  }
                }
                if (option[propertyKey]?.sort !== undefined) {
                  if (option[propertyKey].sort === null) delete layerItem.mark[propertyKey]?.sort;
                  else if (option[propertyKey].sort.constructor.name === "String") {
                    layerItem.mark[propertyKey].sort = option[propertyKey].sort;
                  } else if (option[propertyKey].sort.constructor.name === "Object") {
                    Object.keys(option[propertyKey].sort).forEach(prop => {
                      if (option[propertyKey].sort[prop] === null) delete layerItem.mark[propertyKey].sort[prop];
                      else {
                        if (layerItem.mark[propertyKey]?.sort === undefined) layerItem.mark[propertyKey].sort = {};
                        layerItem.mark[propertyKey].sort[prop] = option[propertyKey].sort[prop];
                      }
                    })
                  }
                }
                if (option[propertyKey]?.scale !== undefined) {
                  if (option[propertyKey].scale === null) delete layerItem.mark[propertyKey]?.scale;
                  else if (option[propertyKey].scale.constructor.name === "Object") {
                    Object.keys(option[propertyKey].scale).forEach(scaleKey => {
                      if (layerItem.mark[propertyKey].scale === undefined) layerItem.mark[propertyKey].scale = {};
                      if (option[propertyKey].scale[scaleKey] === null) delete layerItem.mark[propertyKey].scale[scaleKey];
                      else if (scaleKey === "range") {
                        let newRange = option[propertyKey].scale.range;
                        if (newRange.constructor.name === "Object" && newRange.prod !== undefined) {
                          if (layerItem.mark[propertyKey].scale?.range?.constructor.name === "Array") {
                            layerItem.mark[propertyKey].scale.range = layerItem.mark[propertyKey].scale.range.map(d => d * newRange.prod)
                          }
                        } else if (newRange.constructor.name === "Object" && newRange.by !== undefined) {
                          if (layerItem.mark[propertyKey].scale?.range?.constructor.name === "Array") {
                            layerItem.mark[propertyKey].scale.range = layerItem.mark[propertyKey].scale.range.map(d => d + newRange.by)
                          }
                        } else {
                          layerItem.mark[propertyKey].scale.range = option[propertyKey].scale[scaleKey];
                        }
                      } else layerItem.mark[propertyKey].scale[scaleKey] = option[propertyKey].scale[scaleKey];
                    });
                  }
                }
              }
            } else if (propertyKey === "point") {
              if (option[propertyKey] === null || option[propertyKey] === false) { delete layerItem.mark.point; }
              else {
                if (option[propertyKey] === true) {
                  layerItem.mark.point = true;
                } else if (option[propertyKey].constructor.name === "Object") {
                  if (layerItem.mark.point === undefined || layerItem.mark.point === true) layerItem.mark.point = {};
                  Object.keys(option[propertyKey]).forEach(subPropkey => {
                    if (option[propertyKey][subPropkey] == null) {
                      delete layerItem.mark.point[subPropkey]
                    } else {
                      layerItem.mark.point[subPropkey] = option[propertyKey][subPropkey]
                    }
                  })
                }
              }
            } else if (propertyKey === "endMark") {
              if (option[propertyKey] === null || option[propertyKey] === false) { delete layerItem.mark.endMark; }
              else if (option[propertyKey] === true) {
                layerItem.mark.endMark = true;
              }
            } else if (!["role"].includes(propertyKey)) {
              if (option[propertyKey] == null) {
                delete layerItem.mark[propertyKey];
              } else {
                layerItem.mark[propertyKey] = option[propertyKey];
              }
            }
          })
        }
      } else if (action === "replace") {
        if (option.from !== undefined && option.to !== undefined) {
          if (option.from.channel !== undefined && option.to.channel !== undefined) {
            layerItem.mark[option.to.channel] = deepcopy(layerItem.mark[option.from.channel]);
            delete layerItem.mark[option.from.channel];
          }
        }
      }
    }
  })
  if (toRemove.length > 0) {
    toRemove.forEach(li => spec.layer[li] = undefined);
    spec.layer = spec.layer.filter(d => d !== undefined);
  }
  return spec;
}

export function MarkLabelTransformation(role, spec, original, specifier, action, option) {
  spec.layer.forEach((layerItem, lindex) => {
    // layer query
    let toAdd = [];
    let flag = true;
    if ((specifier.mark !== undefined && specifier.mark !== layerItem.mark?.type)) flag = false;
    if (specifier.layer?.id !== undefined && specifier.layer?.id !== layerItem.name) flag = false;
    if (specifier.layer?.index !== undefined && specifier.layer?.index !== lindex) flag = false;

    if (flag) {
      if (action === "modify" || action === "reposition") {
        let markTextIndex = 0;
        layerItem.text?.filter(d => d.type === "on-mark")?.forEach((textItem, ti) => {
          if (specifier.index !== undefined && markTextIndex !== specifier.index) return;
          if (specifier.field !== undefined && textItem.field !== specifier.field) return;
          if (specifier.id !== undefined && textItem.name !== specifier.id) return;
          markTextIndex += 1;
          if (textItem.type === "on-mark") {
            let toChange = [];
            let queryValues = specifier.values, itemValues = textItem.values;
            if (specifier.data) {
              queryValues = spec.data.filter(d => (makeFilterFunction(specifier.data)(d))).map(d => d[textItem.field]);
            }
            if (specifier.text) {
              if (specifier.text.startsWith) {
                if (textItem.items[0].expression?.startsWith("'")) {
                  if (!textItem.items[0].expression.slice(1).startsWith(specifier.text.startsWith)) return;
                } else if (textItem.items[0].expression?.startsWith("(")) {
                  let eval_texts = itemValues.map(d => evalExpression(textItem.items[0].expression.replace(/datum\.value/g, d)));
                  if (eval_texts.every(d => !d.startsWith(specifier.text.startsWith))) return;
                  else {
                    queryValues = itemValues.filter((d, di) => eval_texts[di].startsWith(specifier.text.startsWith))
                  }
                } else {
                  return;
                }
              }
            }
            let valueSetKeep, valueSetDupl;
            if (queryValues) {
              if (itemValues) { // both valued
                if (queryValues.constructor.name === "Object" && queryValues.not !== undefined) { // not
                  valueSetKeep = itemValues.filter(d => queryValues.not.includes(d) || queryValues.not === d);
                } else if (queryValues.constructor.name === "Array") {
                  valueSetKeep = itemValues.filter(d => !queryValues.includes(d));
                }
              } else {
                itemValues = deepcopy(spec.datatype?.[textItem.field]?.values || spec.datatype?.stats?.[textItem.field]?.values || []);
                if (queryValues.constructor.name === "Object" && queryValues.not !== undefined) { // not
                  valueSetKeep = itemValues.filter(d => queryValues.not.includes(d) || queryValues.not === d);
                } else if (queryValues.constructor.name === "Array") {
                  valueSetKeep = itemValues.filter(d => !queryValues.includes(d));
                }
              }
              valueSetDupl = itemValues.filter(d => !valueSetKeep.includes(d));
            }
            if (valueSetKeep?.length == 0 || valueSetKeep === undefined) {
              toChange = [textItem];
            } else if (textItem.values === undefined && option.values) {
              textItem.values = option.values;
              toChange = [textItem];
            } else if (valueSetDupl.length > 0) {
              let dup = deepcopy(textItem);
              dup.values = valueSetDupl;
              if (dup.conditions) delete dup.conditions
              toAdd.push({
                "at": ti,
                "item": dup
              });
              textItem.values = valueSetKeep;
              toChange = [dup];
            }
            toChange.forEach(textItem => {
              if (textItem.type === "on-mark") {
                if (specifier.field !== undefined && specifier.field !== textItem.field) return;
                if (specifier.values !== undefined) {
                  if (!specifier.values.some(d => textItem.values.includes(d))) return;
                  if (!textItem.items.some(d => {
                    if (d.condition === undefined) return true;
                    else return specifier.values.some(e => d.condition.includes(e))
                  })) return;
                }

                if (option) {
                  textItem.items.forEach((textElem, tei) => {
                    // global
                    let optionFormat = option.format;
                    let optionExpression = option.expression;
                    if (optionFormat !== undefined || optionExpression !== undefined) {
                      if (specifier.data !== undefined) {
                        let queryStr = toFilterString(specifier.data);
                        if (textElem.expression !== undefined) {
                          if (optionFormat !== undefined && optionExpression !== undefined) {
                            textElem.expression = "(" + queryStr + " ? " + optionExpression.replace(/datum\.label/g, "format(datum.value, '" + optionFormat + "')") + " : " + textElem.expression + ")";
                          } else {
                            textElem.expression = (optionFormat ?
                              "(" + queryStr + " ? format(datum.value, '" + optionFormat + "') : " + textElem.expression + ")" :
                              "(" + queryStr + " ? " + optionExpression + " : datum.value )");
                          }
                        } else if (textElem.format !== undefined) {
                          if (optionFormat !== undefined && optionExpression !== undefined) {
                            textElem.expression = "(" + queryStr + " ? " + optionExpression.replace(/datum\.label/g, "format(datum.value, '" + optionFormat + "')") + " : format(datum.value, '" + textElem.format + "'))";
                          } else {
                            textElem.expression = (optionFormat ?
                              "(" + queryStr + " ? format(datum.value, '" + optionFormat + "') : format(datum.value, '" + textElem.format + "'))" :
                              "(" + queryStr + " ? " + optionExpression + " : format(datum.value, '" + textElem.format + "'))");
                          }
                          delete textElem.format;
                        } else {
                          if (optionFormat !== undefined && optionExpression !== undefined) {
                            textElem.expression = "(" + queryStr + " ? " + optionExpression.replace(/datum\.label/g, "format(datum.value, '" + optionFormat + "')") + " : datum.value)"
                          } else {
                            textElem.expression = (optionFormat ?
                              "(" + queryStr + " ? format(datum.value, '" + optionFormat + "') : datum.value )" :
                              "(" + queryStr + " ? " + optionExpression + " : datum.value )");
                          }
                        }
                      } else if (specifier.data === undefined) {
                        if (optionFormat === null) delete textElem.format;
                        else if (optionFormat) textElem.format = optionFormat;
                        if (optionExpression === null) delete textElem.expression;
                        else if (optionExpression) textElem.expression = optionExpression;
                      }
                    }
                    Object.keys(option).forEach((propertyKey, i) => {
                      if (["width", "align", "fontSize", "fontWeight", "lineHeight", "textAlign", "fontStroke", "fontColor"].includes(propertyKey)) {
                        let _propertyKey = { "textAlign": "align", "fontColor": "color" }[propertyKey] || propertyKey;
                        // textItem.items.forEach((textElem2, ti) => {
                        if (option[propertyKey]?.constructor.name === "Array") {
                          textElem[_propertyKey] = optionOperation(textElem[_propertyKey], option[propertyKey][ti]);
                        } else if (option[propertyKey] !== null) {
                          textElem[_propertyKey] = optionOperation(textElem[_propertyKey], option[propertyKey]);
                        } else delete textElem[_propertyKey];
                        // })
                        if (propertyKey === "width") {
                          if (option[propertyKey] !== null) {
                            if (textItem[propertyKey] === undefined) textItem[propertyKey] = 120;
                            textItem[propertyKey] = optionOperation(textItem[propertyKey], option[propertyKey]);
                          } else delete textItem[propertyKey];
                        }
                        if (specifier.values === undefined && textItem.conditions !== undefined) {
                          textItem.conditions.forEach(conditioned_text => {
                            if (conditioned_text.options[_propertyKey] !== undefined) {
                              conditioned_text.options[_propertyKey] = option[propertyKey];
                            }
                          })
                        }
                      } else if (propertyKey === "offset") {
                        if (option[propertyKey] !== null) textItem["padding"] = optionOperation(textItem["padding"], option[propertyKey]);
                        else textItem["padding"];
                      } else if (propertyKey.startsWith("margin")) {
                        textItem.items.forEach((textElem, ti) => {
                          if (option[propertyKey]?.constructor.name === "Array") {
                            textElem[propertyKey] = optionOperation(textElem[propertyKey], option[propertyKey][ti]);
                          } else if (option[propertyKey] !== null) {
                            textElem[propertyKey] = optionOperation(textElem[propertyKey], option[propertyKey]);
                          } else delete textElem[propertyKey];
                        })
                      } else if (propertyKey === "tick") {
                        if (option[propertyKey] === null) delete textItem.tick;
                        else {
                          if (textItem.tick === undefined) textItem.tick = {};
                          if (option[propertyKey].constructor.name === "Boolean") {
                            textItem.tick = {};
                            textItem.tick.ticks = option[propertyKey];
                          }
                          else if (option[propertyKey].constructor.name === "Object") {
                            Object.keys(option[propertyKey]).forEach(tickKey => {
                              textItem.tick[tickKey] = option[propertyKey][tickKey]
                            })
                          }
                        }
                      } else if (propertyKey === "external") {
                        if (option[propertyKey] === null) {
                          delete textItem.visibility?.["externalize"];
                        } else if (option[propertyKey] == true) {
                          if (textItem.visibility === undefined) textItem.visibility = {};
                          if (textItem.visibility.externalize === undefined) textItem.visibility.externalize = {};
                          if (option[propertyKey]) textItem.visibility.externalize.position = "bottom";
                        } else if (option[propertyKey] == false) {
                          if (textItem.visibility?.externalize !== undefined) delete textItem.visibility.externalize;
                        } else if (option[propertyKey].constructor.name === "Object") {
                          if (textItem.visibility === undefined) textItem.visibility = {};
                          if (textItem.visibility.externalize === undefined) textItem.visibility.externalize = {};
                          if (option[propertyKey].position) textItem.visibility.externalize.position = option[propertyKey].position;
                          if (option[propertyKey].numbering) textItem.visibility.externalize.numbering = option[propertyKey].numbering;
                        }
                      } else if (propertyKey === "numbering") {
                        if (option[propertyKey] === null) {
                          delete textItem.visibility?.externalize?.numbering;
                        } else {
                          if (textItem.visibility === undefined) textItem.visibility = {};
                          if (textItem.visibility.externalize === undefined) textItem.visibility.externalize = {};
                          if (option[propertyKey]) textItem.visibility.externalize.numbering = true;
                        }
                      } else if (["dx", "dy"].includes(propertyKey) && tei == 0) {
                        if (option[propertyKey] !== null) textItem[propertyKey] = optionOperation(textItem[propertyKey], option[propertyKey]);
                        else delete textItem[propertyKey];
                      } else if (propertyKey === "flatten" && option[propertyKey]) {
                        if (textElem.expression) {
                          textElem.expression = textElem.expression.replace(/\<br\/?\>/gi, "");
                        }
                      } else if (propertyKey === "items") {
                        if ((option.items.constructor.name === "Array" && option.items[tei] !== undefined) || (option.items.index !== undefined && tei == option.items.index)) {
                          let optionFormat = option.items?.format || option.items?.[tei]?.format;
                          let optionExpression = option.items?.expression || option.items?.[tei]?.expression;
                          if (optionFormat !== undefined || optionExpression !== undefined) {
                            if (specifier.data !== undefined) {
                              let queryStr = toFilterString(specifier.data);
                              if (textElem.expression !== undefined) {
                                if (optionFormat !== undefined && optionExpression !== undefined) {
                                  textElem.expression = "(" + queryStr + " ? " + optionExpression.replace(/datum\.label/g, "format(datum.value, '" + optionFormat + "')") + " : " + textElem.expression + ")";
                                } else {
                                  textElem.expression = (optionFormat ?
                                    "(" + queryStr + " ? format(datum.value, '" + optionFormat + "') : " + textElem.expression + ")" :
                                    "(" + queryStr + " ? " + optionExpression + " : datum.value )");
                                }
                              } else if (textElem.format !== undefined) {
                                if (optionFormat !== undefined && optionExpression !== undefined) {
                                  textElem.expression = "(" + queryStr + " ? " + optionExpression.replace(/datum\.label/g, "format(datum.value, '" + optionFormat + "')") + " : format(datum.value, '" + textElem.format + "'))";
                                } else {
                                  textElem.expression = (optionFormat ?
                                    "(" + queryStr + " ? format(datum.value, '" + optionFormat + "') : format(datum.value, '" + textElem.format + "'))" :
                                    "(" + queryStr + " ? " + optionExpression + " : format(datum.value, '" + textElem.format + "'))");
                                }
                                delete textElem.format;
                              } else {
                                if (optionFormat !== undefined && optionExpression !== undefined) {
                                  textElem.expression = "(" + queryStr + " ? " + optionExpression.replace(/datum\.label/g, "format(datum.value, '" + optionFormat + "')") + " : datum.value)"
                                } else {
                                  textElem.expression = (optionFormat ?
                                    "(" + queryStr + " ? format(datum.value, '" + optionFormat + "') : datum.value )" :
                                    "(" + queryStr + " ? " + optionExpression + " : datum.value )");
                                }
                              }
                            } else if (specifier.data === undefined) {
                              if (optionFormat === null) delete textElem.format;
                              else if (optionFormat) textElem.format = optionFormat;
                              if (optionExpression === null) delete textElem.expression;
                              else if (optionExpression) textElem.expression = optionExpression;
                            }
                          }

                          let itemOption = (option.items.constructor.name === "Array" ? option.items[tei] : option.items);
                          Object.keys(itemOption).forEach(subPropkey => {
                            if (!["expression", "format", "condition", "index"].includes(propertyKey)) {
                              let _subPropkey = { "align": "textAlign" }[subPropkey] || subPropkey;
                              if (itemOption[subPropkey] == null) delete textElem[_subPropkey];
                              else textElem[_subPropkey] = itemOption[subPropkey];
                            }
                          });
                        } else return;
                      } else if (!["expression", "format", "condition", "items", "dx", "dy"].includes(propertyKey)) {
                        const keymap = { "anchor": "anchorAlign" };
                        let propertyKey2 = (keymap[propertyKey] ? keymap[propertyKey] : propertyKey);
                        if (option[propertyKey] !== null) textItem[propertyKey2] = optionOperation(textItem[propertyKey2], option[propertyKey]);
                        else delete textItem[propertyKey2];
                        if (specifier.values === undefined && textItem.conditions !== undefined) {
                          textItem.conditions.forEach(conditioned_text => {
                            if (propertyKey === "anchor" && conditioned_text.options.anchor !== undefined) {
                              conditioned_text.options.anchor.anchorAlign = option[propertyKey];
                            }
                            if (conditioned_text.options[propertyKey2] !== undefined) {
                              conditioned_text.options[propertyKey2] = option[propertyKey];
                            }
                          })
                        }
                      }
                    });
                  });
                }
              }
            });
          }
        });
      } else if (action === "add") {
        if (option.values !== undefined) {
          let candidateItemIndex = layerItem.text.map((textItem, ti) => {
            if (textItem.type === "on-mark") {
              if (specifier.field !== undefined && specifier.field === textItem.field) return ti;
              else if (specifier.field === undefined) return ti;
              return undefined;
            } else {
              return undefined;
            }
          })
          let candidateItemLength = candidateItemIndex.map(ti => layerItem.text[ti]?.values?.length || -1);
          let candidateMaxLength = d3.max(candidateItemLength);
          let indexTo = candidateItemIndex.filter(ti => candidateMaxLength == layerItem.text[ti]?.values?.length)[0];
          if (indexTo !== undefined && indexTo >= 0) {
            layerItem.text[indexTo].values.push(...option.values);
          }
        } else {
          let markTextIndex = 0;
          layerItem.text?.forEach(textItem => {
            if (specifier.index !== undefined && markTextIndex !== specifier.index) return;
            if (specifier.field !== undefined && textItem.field !== specifier.field) return;
            if (specifier.id !== undefined && textItem.name !== specifier.id) return;
            markTextIndex += 1;
            if (textItem.type === "on-mark") {
              // query by specifier
              // indexing
              let indexTo;
              if (option.items?.index !== undefined) indexTo = option.items.index;
              else indexTo = textItem.items.length;
              if (option.items?.constructor.name === "Array") {
                option.items.forEach(addItem => {
                  if (addItem.index !== undefined) indexTo = addItem.index;
                  textItem.items?.splice(indexTo, 0, addItem);
                })
              } else if (option.items?.constructor.name === "Object") {
                textItem.items.push(option.items);
              }
            }
          });
        }
      } else if (action === "remove") {
        let markTextIndex = 0;
        layerItem?.text?.forEach(textItem => {
          if (textItem.type === "on-mark" && (specifier.field === undefined || specifier.field === textItem.field)) {
            if (specifier.index !== undefined && markTextIndex !== specifier.index) {
              markTextIndex += 1; return;
            }
            if (specifier.id && textItem.name !== specifier.id) return;
            if (option?.items) {
              let toRemove = [];
              if (option.items.index?.constructor.name === "Number") toRemove = [option.items.index];
              else if (option.items.index?.constructor.name === "Array") toRemove = option.items.index.map(i => i);
              if (toRemove.length > 0) textItem.items = textItem.items.filter((d, i) => !toRemove.includes(i));
            } else if (specifier?.values) {
              if (textItem.values) textItem.values = textItem.values.filter(d => !specifier.values.includes(d));
              else textItem.values = spec.datatype[textItem.field].values.filter(d => !specifier.values.includes(d));
            }
            else if (option?.values) {
              if (textItem.values) textItem.values = textItem.values.filter(d => !option.values.includes(d));
              else textItem.values = spec.datatype[textItem.field].values.filter(d => !option.values.includes(d));
            } else {
              textItem.delete = true;
            }
            markTextIndex += 1;
          }
        });
        layerItem.text = layerItem?.text?.filter(d => !d.delete);
      } else if (action === "replace") {
        if (option?.to !== undefined) {
          if (option.to.role === "axis.label") {
            let oldLabelItems = layerItem.text.map((textItem, ti) => {
              if (textItem.type === "on-mark" && (specifier.field === undefined || textItem.field === specifier.field)) {
                return ti
              }
            }).filter(d => d !== undefined);
            let nValues = d3.max(oldLabelItems.map(d => layerItem.text[d].values?.length || spec.datatype[layerItem.text[d].field].values));
            let modItem = oldLabelItems.filter(d => layerItem.text[d].values?.length == nValues || (layerItem.text[d].values === undefined))[0];
            let conditioned_items = oldLabelItems.map(d => (layerItem.text[d].items.filter(e => e.condition !== undefined))).filter(d => d.length > 0);
            let values = oldLabelItems.map(d => layerItem.text[d].values).filter(d => d !== undefined);
            let newLabelItem = deepcopy(layerItem.text[modItem]);
            newLabelItem.type = "on-axis";
            if (newLabelItem.values !== undefined) values.forEach(v => newLabelItem.values.push(...v));
            if (conditioned_items.length > 0) newLabelItem.items.push(...conditioned_items);
            Object.keys(option.to).forEach(propKey => {
              if (!["role"].includes(propKey)) {
                if (["width", "align", "fontSize", "fontWeight", "lineHeight", "textAlign", "fontStroke", "fontColor"].includes(propKey)) {
                  let _propKey = { "textAlign": "align", "fontColor": "color" }[propKey] || propKey;
                  newLabelItem.items?.forEach(tItem => {
                    if (option.to[propKey] === null) delete tItem[_propKey];
                    else tItem[_propKey] = option.to[propKey];
                  });
                } else {
                  if (option.to[propKey] === null) delete newLabelItem[propKey];
                  else newLabelItem[propKey] = option.to[propKey];
                }
              }
            })
            layerItem.text = layerItem.text.filter((textItem, ti) => !oldLabelItems.includes(ti))
            layerItem.text.push(newLabelItem);
          } else if (option.to.role === "legend") {
            let oldLabelItems = layerItem.text.map((textItem, ti) => {
              if (textItem.type === "on-mark" && (specifier.field === undefined || textItem.field === specifier.field)) {
                return ti
              }
            }).filter(d => d !== undefined);
            let nValues = d3.max(oldLabelItems.map(d => layerItem.text[d].values?.length || spec.datatype[layerItem.text[d].field].values.length));
            let modItem = oldLabelItems.filter(d => layerItem.text[d].values?.length == nValues || layerItem.text[d].values === undefined)[0];
            let conditioned_items = oldLabelItems.map(d => (layerItem.text[d].items.filter(e => e.condition !== undefined))).filter(d => d.length > 0);
            let values = oldLabelItems.map(d => layerItem.text[d].values).filter(d => d !== undefined);
            let newLabelItem = deepcopy(layerItem.text[modItem]);
            newLabelItem.type = "legend";
            // if (newLabelItem.values !== undefined) values.forEach(v => newLabelItem.values.push(...v));
            if (conditioned_items.length > 0) newLabelItem.items.push(...conditioned_items);
            if (newLabelItem.dx) delete newLabelItem.dx;
            if (newLabelItem.dy) delete newLabelItem.dy;
            Object.keys(option.to).forEach(propKey => {
              if (!["role"].includes(propKey)) {
                if (option.to[propKey] === null) delete newLabelItem[propKey];
                newLabelItem[propKey] = option.to[propKey];
              }
            })
            layerItem.text = layerItem.text.filter((textItem, ti) => !oldLabelItems.includes(ti))
            layerItem.text.push(newLabelItem);
          }
        }
      }
    }

    if (toAdd.length > 0) {
      let acnt = 0;
      toAdd.forEach(addItem => {
        layerItem.text.splice(addItem.at + acnt || layerItem.text.length, 0, addItem.item)
        acnt++;
      })
    }
  });
  return spec;
}

export function MarkLabelTickTransformation(role, spec, original, specifier, action, option) {
  spec.layer.forEach((layerItem, lindex) => {
    // layer query
    let toAdd = [];
    let flag = isLayerWithQuery(layerItem, lindex, specifier.mark, specifier.layer?.index || specifier.index, specifier.layer?.id || specifier.id);
    // let encoded_fields = Object.keys(layerItem.mark).map(d => d.field).filter(d => d !== undefined);
    let encoded_channels = Object.keys(layerItem.mark).filter(d => propChannels.includes(d));
    if (specifier.mark !== undefined && specifier.mark !== layerItem.mark.type) flag = false;
    if (specifier.channel !== undefined) {
      if (specifier.channel.constructor.name === "String" && !encoded_channels.includes(specifier.channel)) flag = false;
      else if (specifier.channel.constructor.name === "Array") {
        if (specifier.channel.field !== undefined && !specifier.channel.every(ch => encoded_channels.includes(ch))) flag = false;
      }
    }
    if (flag) {
      if (action === "add") {
        layerItem.text.forEach((textItem, ti) => {
          if (textItem.type === "on-mark") {
            let queryValues = specifier.values, itemValues = textItem.values;
            if (queryValues) {
              let valueSetKeep, valueSetDupl;
              if (itemValues) { // both valued
                if (queryValues.constructor.name === "Object" && queryValues.not !== undefined) { // not
                  valueSetKeep = itemValues.filter(d => queryValues.not.includes(d) || queryValues.not === d);
                } else if (queryValues.constructor.name === "Array") {
                  valueSetKeep = itemValues.filter(d => !queryValues.includes(d));
                }
              } else {
                if (queryValues.constructor.name === "Object" && queryValues.not !== undefined) { // not
                  valueSetKeep = datatype[textItem.field].filter(d => queryValues.not.includes(d) || queryValues.not === d);
                } else if (queryValues.constructor.name === "Array") {
                  valueSetKeep = datatype[textItem.field].filter(d => !queryValues.includes(d));
                }
              }
              valueSetDupl = itemValues.filter(d => !valueSetKeep.includes(d));
              if (valueSetKeep.length == 0) {
                textItem.tick = true;
              } else if (valueSetDupl.length > 0) {
                let dup = deepcopy(textItem);
                dup.values = valueSetDupl;
                dup.tick = true;
                toAdd.push({
                  "at": ti,
                  "item": dup
                });
                textItem.values = valueSetKeep;
              }
            }
          }
        });
      } else if (action === "remove") {
        layerItem.text.forEach((textItem, ti) => {
          if (specifier.id !== undefined && textItem.name !== specifier.id) return;
          if (specifier.index !== undefined && ti !== specifier.index) return;
          if (textItem.type === "on-mark") {
            let queryValues = specifier.values, itemValues = textItem.values;
            if (queryValues) {
              let valueSetKeep, valueSetDupl;
              if (itemValues) { // both valued
                if (queryValues.constructor.name === "Object" && queryValues.not !== undefined) { // not
                  valueSetKeep = itemValues.filter(d => queryValues.not.includes(d) || queryValues.not === d);
                } else if (queryValues.constructor.name === "Array") {
                  valueSetKeep = itemValues.filter(d => !queryValues.includes(d));
                }
              } else {
                if (queryValues.constructor.name === "Object" && queryValues.not !== undefined) { // not
                  valueSetKeep = datatype[textItem.field].filter(d => queryValues.not.includes(d) || queryValues.not === d);
                } else if (queryValues.constructor.name === "Array") {
                  valueSetKeep = datatype[textItem.field].filter(d => !queryValues.includes(d));
                }
              }
              valueSetDupl = itemValues.filter(d => !valueSetKeep.includes(d));
              if (valueSetKeep.length == 0) {
                textItem.tick = false;
              } else if (valueSetDupl.length > 0) {
                let dup = deepcopy(textItem);
                dup.values = valueSetDupl;
                dup.tick = false;
                toAdd.push({
                  "at": ti,
                  "item": dup
                });
                textItem.values = valueSetKeep;
              }
            } else {
              textItem.tick = false;
            }
          }
        });
      } else if (action === "modify") {
        layerItem.text.forEach((textItem, ti) => {
          if (textItem.type === "on-mark") {
            if (specifier.field && specifier.field !== textItem.field) return;
            let queryValues = specifier.values, itemValues = textItem.values;
            if (queryValues) {
              let valueSetKeep, valueSetDupl;
              if (itemValues) { // both valued
                if (queryValues.constructor.name === "Object" && queryValues.not !== undefined) { // not
                  valueSetKeep = itemValues.filter(d => queryValues.not.includes(d) || queryValues.not === d);
                } else if (queryValues.constructor.name === "Array") {
                  valueSetKeep = itemValues.filter(d => !queryValues.includes(d));
                }
              } else {
                if (queryValues.constructor.name === "Object" && queryValues.not !== undefined) { // not
                  valueSetKeep = datatype[textItem.field].filter(d => queryValues.not.includes(d) || queryValues.not === d);
                } else if (queryValues.constructor.name === "Array") {
                  valueSetKeep = datatype[textItem.field].filter(d => !queryValues.includes(d));
                }
              }
              valueSetDupl = itemValues.filter(d => !valueSetKeep.includes(d));
              if (valueSetKeep.length > 0) {
                textItem.values = valueSetKeep;
                if (textItem.tick === undefined) textItem.tick = {};
                Object.keys(option).forEach(property => {
                  let _prop = { "stroke": "color", "strokeWidth": "width" }[property] || property;
                  if (option[property] == null)
                    delete textItem.tick[_prop];
                  else textItem.tick[_prop] = option[property];
                })
              }
              if (valueSetDupl.length > 0) {
                let dup = deepcopy(textItem);
                dup.values = valueSetDupl;
                if (dup.tick === undefined) dup.tick = {};
                Object.keys(option).forEach(property => {
                  let _prop = { "stroke": "color", "strokeWidth": "width" }[property] || property;
                  if (option[property] == null)
                    delete textdupItem.tick[_prop];
                  else dup.tick[_prop] = option[property];
                });
                toAdd.push({
                  "at": ti,
                  "item": dup
                });
              }
            } else {
              if (textItem.tick === undefined) textItem.tick = {};
              Object.keys(option).forEach(property => {
                let _prop = { "stroke": "color", "strokeWidth": "width" }[property] || property;
                if (option[property] == null)
                  delete textItem.tick[_prop];
                else textItem.tick[_prop] = option[property];
              })
            }

          }
        });
      }
    }
    if (toAdd.length > 0) {
      let acnt = 0;
      toAdd.forEach(addItem => {
        layerItem.text.splice(addItem.at + acnt || layerItem.text.length, 0, addItem.item)
        acnt++;
      })
    }
  });
  return spec;
}